module.exports = __webpack_public_path__ + "img/seiji.c2499b96.jpg";